(() => {
  if (window.SuncoHomeInitialized) return;
  window.SuncoHomeInitialized = true;

  const initSharedProductCards = (root = document) => {
    window.SuncoPlp?.setupProductCards?.(root);
  };

  const updateProductSlider = (slider) => {
    const viewport = slider.querySelector('[data-sunco-home-products-viewport]');
    if (!viewport) return;

    const previous = slider.querySelector('[data-sunco-home-products-prev]');
    const next = slider.querySelector('[data-sunco-home-products-next]');
    const canScroll = viewport.scrollWidth > viewport.clientWidth + 2;
    const atStart = viewport.scrollLeft <= 1;
    const atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;

    slider.classList.toggle('is-scrollable', canScroll);

    if (previous) previous.disabled = !canScroll || atStart;
    if (next) next.disabled = !canScroll || atEnd;
  };

  const scrollProductSlider = (slider, direction) => {
    const viewport = slider.querySelector('[data-sunco-home-products-viewport]');
    const track = slider.querySelector('[data-sunco-home-products-track]');
    const card = track?.querySelector('.sunco-plp-card');

    if (!viewport || !card) return;

    const trackStyles = window.getComputedStyle(track);
    const gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0') || 0;
    const distance = card.getBoundingClientRect().width + gap;

    viewport.scrollBy({
      left: direction * distance,
      behavior: 'smooth',
    });
  };

  const initProductSliders = (root = document) => {
    root.querySelectorAll('[data-sunco-home-product-slider]').forEach((slider) => {
      if (slider.dataset.suncoHomeSliderReady === 'true') return;
      slider.dataset.suncoHomeSliderReady = 'true';

      const viewport = slider.querySelector('[data-sunco-home-products-viewport]');
      const previous = slider.querySelector('[data-sunco-home-products-prev]');
      const next = slider.querySelector('[data-sunco-home-products-next]');

      previous?.addEventListener('click', () => scrollProductSlider(slider, -1));
      next?.addEventListener('click', () => scrollProductSlider(slider, 1));
      viewport?.addEventListener('scroll', () => updateProductSlider(slider), { passive: true });

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(() => updateProductSlider(slider));
        if (viewport) observer.observe(viewport);
      }

      requestAnimationFrame(() => updateProductSlider(slider));
    });
  };

  const initProductTabs = (root = document) => {
    root.querySelectorAll('[data-sunco-home-product-tabs]').forEach((section) => {
      if (section.dataset.suncoHomeTabsReady === 'true') return;
      section.dataset.suncoHomeTabsReady = 'true';

      const tabs = Array.from(section.querySelectorAll('[data-sunco-home-product-tab]'));
      const panels = Array.from(section.querySelectorAll('[data-sunco-home-product-panel]'));

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const targetId = tab.getAttribute('aria-controls');
          tabs.forEach((candidate) => {
            candidate.setAttribute('aria-selected', candidate === tab ? 'true' : 'false');
            candidate.tabIndex = candidate === tab ? 0 : -1;
          });
          panels.forEach((panel) => {
            panel.hidden = panel.id !== targetId;
          });

          section.querySelectorAll('[data-sunco-home-product-slider]').forEach((slider) => {
            requestAnimationFrame(() => updateProductSlider(slider));
          });
          requestAnimationFrame(() => initSharedProductCards(section));
        });

        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const currentIndex = tabs.indexOf(tab);
          const nextIndex = (currentIndex + direction + tabs.length) % tabs.length;
          tabs[nextIndex].focus();
          tabs[nextIndex].click();
        });
      });

      initProductSliders(section);
      initSharedProductCards(section);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initProductTabs();
    initProductSliders();
    initSharedProductCards();
  });
  document.addEventListener('shopify:section:load', (event) => {
    initProductTabs(event.target);
    initProductSliders(event.target);
    initSharedProductCards(event.target);
  });
})();
